import type { RouteRecordRaw } from "vue-router";
import { XApiPermissions } from "@/core/enums";
import { useModuleSettings } from "@/core/composables/useModuleSettings";
import { useUser } from "@/shared/account";

const Info = () => import("@/pages/company/info.vue");
const Members = () => import("@/pages/company/members.vue");
const manageCompanies = () => import("@/pages/company/manageCompanies.vue");
const OnboardProducts = () => import("@/pages/company/onboard-products.vue");

export const corporateRoutes: RouteRecordRaw[] = [
  { path: "info", name: "CompanyInfo", component: Info },
  { path: "members", name: "CompanyMembers", component: Members },
  { path: "manageCompanies", name: "ManageCompanies", component: manageCompanies },
  {
    path: "onboard-products",
    name: "OnboardProducts",
    component: OnboardProducts,
    beforeEnter(_to, _from, next) {
      const { checkPermissions } = useUser();
      const { isEnabled } = useModuleSettings("Convotis.DeployAIOnboarding");
      if (checkPermissions(XApiPermissions.CanEditOrganization) && isEnabled("DeployAIOnboarding.ProductOnboardingEnabled")) {
        next();
      } else {
        next({ name: "CompanyInfo" });
      }
    },
  },
];
